import { notification } from "antd";

export const updateNestedObjectMulti = <T>(
  obj: T,
  updates: { path: string[]; value: any }[]
): T => {
  return updates.reduce((acc, { path, value }) => {
    return setDeepValue(acc, path, value);
  }, obj);
};

const setDeepValue = <T>(obj: T, path: string[], value: any): T => {
  if (path.length === 0) return obj;

  const [firstKey, ...restPath] = path;

  return {
    ...obj,
    [firstKey]: restPath.length
      ? setDeepValue((obj as any)[firstKey] ?? {}, restPath, value)
      : value,
  };
};

export const copyToClipboard = async ({ text, successMessage, errMessage }) => {
  try {
    await navigator.clipboard.writeText(text ?? "");
    notification.success({
      message: successMessage,
    });
  } catch (err) {
    notification.error({
      message: errMessage,
    });
  }
};

export const downloadBackupCodes = (backupCodes: string[]) => {
  const blob = new Blob([backupCodes.join(", ")], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "backup_codes.txt";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
